import ContactsIcon from "@mui/icons-material/Contacts";
import { Box, SxProps } from "@mui/material";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

import { FlexBox } from "./FlexBox";

type AttachmentKind = "image" | "video" | "vcard";

function attachmentKind(
  contentType: string | null | undefined
): AttachmentKind {
  if (!contentType) {
    return "image";
  }

  if (contentType.startsWith("image/")) {
    return "image";
  }

  if (contentType.startsWith("video/")) {
    return "video";
  }

  return "vcard";
}

export default function MediaAttachment({
  src,
  contentType,
  sx = {},
}: {
  src: string;
  contentType?: string | null;
  sx?: SxProps;
}): ReactElement {
  switch (attachmentKind(contentType)) {
    case "image":
      return (
        <Box
          component="img"
          sx={{ maxHeight: "100px", maxWidth: "100%", ...sx }}
          src={src}
        />
      );

    case "video":
      return (
        <Box
          component="video"
          sx={{ maxHeight: "100px", maxWidth: "100%", ...sx }}
          src={src}
          controls
          muted
        />
      );

    case "vcard":
      return (
        <FlexBox
          alignItems="center"
          sx={{
            width: "250px",
            height: "60px",
            border: `1px solid ${palette.darkGray}`,
            padding: 2,
            ...sx,
          }}
        >
          <Box>
            <ContactsIcon />
          </Box>
          <Box sx={{ flex: 1, marginLeft: 2 }}>
            <a href={src} target="_blank" rel="noopener noreferrer">
              vCard Attachment
            </a>
          </Box>
        </FlexBox>
      );
  }
}
